/**
 * 汎用モーダル
 * 全 <dialog> を自動検出し、data-modal-open / data-modal-close で開閉を制御
 *
 * HTML 例:
 *   <button data-modal-open="modal-map">地図を見る</button>
 *   <dialog id="modal-map">
 *     ...
 *     <button data-modal-close>閉じる</button>
 *   </dialog>
 */

const waitAnimations = (el) => {
  const animations = el.getAnimations();
  if (animations.length === 0) return Promise.resolve();
  return Promise.allSettled(animations.map((a) => a.finished));
};

const initModal = (dialog) => {
  const openTriggers = document.querySelectorAll(
    `[data-modal-open="${dialog.id}"]`
  );
  const closeTriggers = dialog.querySelectorAll("[data-modal-close]");

  if (openTriggers.length === 0) return;

  let isTransitioning = false;
  let currentTrigger = null;

  const open = () => {
    if (isTransitioning) return;
    isTransitioning = true;
    dialog.showModal();

    requestAnimationFrame(async () => {
      dialog.setAttribute("data-active", "true");
      await waitAnimations(dialog);
      isTransitioning = false;
    });
  };

  const close = async () => {
    if (isTransitioning) return;
    isTransitioning = true;
    dialog.setAttribute("data-active", "false");

    await waitAnimations(dialog);
    dialog.close();

    if (currentTrigger) {
      currentTrigger.focus();
      currentTrigger = null;
    }
    isTransitioning = false;
  };

  openTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      currentTrigger = trigger;
      open();
    });
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      close();
    });
  });

  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) {
      close();
    }
  });

  dialog.addEventListener("cancel", (e) => {
    e.preventDefault();
    close();
  });
};

export const modalMap = () => {
  document.querySelectorAll("dialog").forEach(initModal);
};
